import loginApi from '@/api/login';
import axios from '@/utils/request';
import storageManagement from '@/utils/storageManagement';

const state = {
  token: localStorage.getItem('user-token') || '',
  status: '',
};

const getters = {
  isAuthenticated: (loginState) => !!loginState.token,
  authStatus: (loginState) => loginState.status,
};

const mutations = {
  authRequest(loginState) {
    const myState = loginState;
    myState.status = 'loading';
  },
  authSuccess(loginState, token) {
    const myState = loginState;
    myState.status = 'success';
    myState.token = token;
  },
  authError(loginState) {
    const myState = loginState;
    myState.status = 'error';
  },
  authLogout(loginState) {
    const myState = loginState;
    myState.token = '';
    myState.status = '';
  },
};

const actions = {
  authRequest({ commit, dispatch }, userData) {
    return new Promise((resolve, reject) => {
      // start requesting
      commit('authRequest');
      loginApi.loginRequest(userData)
        .then((res) => {
          // auth success
          if (res.code === 200) {
            const { token, userDetailInfo } = res.data;
            // 保存上次选择的车站ID
            const lastWorkUnitId = localStorage.getItem('currentWorkUnitId');
            // 清除旧的localStorage数据
            localStorage.removeItem('workUnits');
            // 信息本地存储
            localStorage.setItem('userToken', token);
            axios.defaults.headers.common.Authorization = `Bearer ${token}`;
            dispatch('userRequest', userDetailInfo); // 存储用户信息
            dispatch('getWorkUnits').then((workUnits) => {
              console.log(workUnits);
              // 优先使用上次选择的车站，如果没有则使用第一个车站
              let activeWorkUnit;
              if (lastWorkUnitId) {
                activeWorkUnit = workUnits.find(el => el.workUnitId === parseInt(lastWorkUnitId));
              }
              if (!activeWorkUnit) {
                activeWorkUnit = workUnits[0];
              }
              commit('changeStationID', activeWorkUnit.workUnitId);
            });
            commit('authSuccess', token);
            resolve(res);
          } else {
            const error = new Error(res.msg);
            commit('authError', error);
            reject(error);
          }
        })
        .catch((err) => {
          // auth error
          storageManagement.removeStorage();
          commit('authError', err);
          reject(new Error('登录出现错误'));
        });
    });
  },
  authLogout({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      // 不管请求是否成功，都移除登录信息
      loginApi.logoutRequest()
        .then((res) => {
          storageManagement.removeStorage();
          delete axios.defaults.headers.common.Authorization;
          commit('authLogout');
          dispatch('removeUserProfile');
          resolve(res);
        })
        .catch((err) => {
          storageManagement.removeStorage();
          delete axios.defaults.headers.common.Authorization;
          commit('authLogout');
          dispatch('removeUserProfile');
          reject(err);
        });
    });
  },
  tokenInvalid({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      storageManagement.removeStorage();
      delete axios.defaults.headers.common.Authorization;
      commit('authLogout');
      dispatch('removeUserProfile');
      resolve('token失效处理执行成功');
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
